import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Button from 'react-bootstrap/button'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'
import FormHeader from '../components/Header.jsx'
import { useGetChildQuery } from '../redux/api/childApi.js'
import { setSelectedUser } from '../redux/slice/userSlice.js'
import formtextStyle from './cssModule/Roleformheader.module.css'
import ChildInfoCard from './Childcard'
import Children from './Children'
import FormModal from './FormModal'
import childrenCss from './cssModule/children.module.css'
import { format } from 'date-fns'

const characters = ['octopus', 'penguin', 'shark', 'whale', 'seal', 'dolphin']

const SelectChild = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { selectedUser } = useSelector((state) => state.user)
  const { userToken } = useSelector((state) => state.auth)
  const { data = [], isLoading, isSuccess, isError, error } = useGetChildQuery({ userToken })

  const [isEdit, setIsEdit] = useState(false)
  const [show, setShow] = useState(false)

  const [search, setSearch] = useState('')
  const [sortBy, setSortBy] = useState('name_asc')
  const initialValues = {
    username: '',
    class: '',
    special_need: '',
    parent_name: '',
    school_name: '',
    gender: '',
    dob: '',
    person_type: 'child',
    image: '',
  }
  const [formData, setFormData] = useState(initialValues)

  useEffect(() => {
    if (isSuccess) {
      const user = selectedUser || (data?.length && data[0]) || null
      dispatch(setSelectedUser(user))
    }
  }, [isSuccess, dispatch])

  const handleAdd = () => {
    setFormData(initialValues)
    setIsEdit(false)
    setShow(true)
  }
  const handleEdit = (data) => {
    setFormData({ ...data, dob: format(new Date(data.dob), 'yyyy-MM-dd') })
    setIsEdit(true)
    setShow(true)
  }

  const getCharacterFromUrl = (imageUrl) => {
    if (!imageUrl) return 'unassigned'
    const match = imageUrl.toLowerCase().match(/\/([^/]+)\.[^/.]+$/)
    if (!match) return 'unassigned'

    const filename = match[1]
    if (filename.includes('no_role')) return '#'

    const found = characters.find((char) => filename.includes(char))
    return found || 'unassigned'
  }

  const filteredChildren = search?.length > 2 ? data.filter((d) => d.username.toLowerCase().includes(search.toLowerCase())) : [...data]

  // Sort and group children based on selection
  const sortedChildren = [...filteredChildren].sort((a, b) => {
    switch (sortBy) {
      case 'name_asc':
        return a.username.localeCompare(b.username)
      case 'character':
        const charA = getCharacterFromUrl(a.image)
        const charB = getCharacterFromUrl(b.image)
        if (charA === charB) {
          return a.username.localeCompare(b.username)
        }
        return charA.localeCompare(charB)
      case 'default':
      default:
        return 0
    }
  })

  // Group children by first letter or character
  const groupedChildren =
    sortBy === 'name_asc' || sortBy === 'character'
      ? sortedChildren.reduce((groups, child) => {
          const groupKey = sortBy === 'name_asc' ? child.username.charAt(0).toUpperCase() : getCharacterFromUrl(child.image)
          if (!groups[groupKey]) {
            groups[groupKey] = []
          }
          groups[groupKey].push(child)
          return groups
        }, {})
      : { '': sortedChildren }

  return (
    <>
      <FormHeader />
      <Container>
        <Row>
          <Col md={4} className={`${formtextStyle.wrapper} mt-0`}>
            <h3 className='text-capitalize'>Users</h3>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <input type='text' placeholder='Search' value={search} onChange={(e) => setSearch(e.target.value)} />
          </Col>
          <Col></Col>
          <Col md={4} xl={2}>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              style={{
                width: '200px',
              }}
            >
              <option value='name_asc'>Sort by Name (A-Z)</option>
              <option value='character'>Sort by Character</option>
              <option value='default'>Default</option>
            </select>
          </Col>
          <Col md={4} xl={2}>
            <button className={`${childrenCss.addBtn} mt-0`} onClick={handleAdd}>
              + Add User
            </button>
          </Col>
        </Row>
        {isLoading ? (
          'loading.....'
        ) : isError ? (
          error.message
        ) : data.length == 0 ? (
          <Children handleAdd={handleAdd} />
        ) : (
          <div className='my-3'>
            {sortBy === 'name_asc' || sortBy === 'character' ? (
              Object.keys(groupedChildren)
                .sort()
                .map((letter) => (
                  <React.Fragment key={letter}>
                    <Row>
                      <Col xs={12}>
                        <h2
                          style={{
                            fontSize: '24px',
                            padding: '0 12px',
                            fontWeight: 'bold',
                            color: '#333',
                            marginBottom: '15px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            textTransform: 'capitalize',
                          }}
                        >
                          {letter}
                          <span
                            style={{
                              fontSize: '16px',
                              color: '#666',
                              fontWeight: 'normal',
                            }}
                          >
                            ({groupedChildren[letter].length})
                          </span>
                        </h2>
                      </Col>
                    </Row>
                    <Row>
                      {groupedChildren[letter].map((child) => (
                        <ChildInfoCard key={child.user_uid} child={child} handleEdit={handleEdit} />
                      ))}
                    </Row>
                  </React.Fragment>
                ))
            ) : (
              <Row>
                {sortedChildren.map((child) => (
                  <ChildInfoCard key={child.user_uid} child={child} handleEdit={handleEdit} />
                ))}
              </Row>
            )}
          </div>
        )}
      </Container>

      <div className='position-sticky w-100 p-2 bottom-0 start-0' style={{ backgroundColor: '#fbfcfc', zIndex: 2 }}>
        <Container>
          <Row>
            <Col md={4} className={`${childrenCss.btnContainer}`}>
              <Button onClick={() => navigate('/')} className='common-btn full-btn w-100 m-0' disabled={filteredChildren.length === 0 || !selectedUser}>
                Continue
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
      {show && <FormModal isEdit={isEdit} show={show} setShow={setShow} formData={formData} setFormData={setFormData} />}
    </>
  )
}

export default SelectChild
